module.exports = __webpack_public_path__ + "img/PPMPRA2.9906007b.png";